module.exports = __webpack_public_path__ + "static/assets/3f4a085ef0e43a73484375e55eaa5eb2.png";